var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: {
        id: "confirmDiscardModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "pricesModalTitle",
        "aria-hidden": "true",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog ", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.leavepage")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.confirmunsavedchanges")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-light",
                attrs: { type: "button" },
                on: { click: _vm.onCancel }
              },
              [_vm._v(_vm._s(_vm.$t("button.continueedit")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-web",
                attrs: { type: "button" },
                on: { click: _vm.onConfirm }
              },
              [_vm._v(_vm._s(_vm.$t("button.leave")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-073748a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-073748a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseConfirmDiscardModal.vue
// module id = null
// module chunks = 